module.exports = __webpack_public_path__ + "51685d99c004a012ad6b985bc5e3e5b1.png";